enum SCOPE_TYPES {
	DOMAIN = 'Domain',
	LANG = 'Language',
	URL = 'Url',
	ISSUE_TYPES = 'Issue Types',
	ISSUE_SEVERITIES = 'Severities'
}

export { SCOPE_TYPES };
